import React from "react";

import { PERMISSION } from "src/utils/constant_permission";

const TreasureBoxPlaysHistoryList = React.lazy(() => import('src/pages/treasure_box_plays/TreasureBoxPlaysHistoryList'));

// One list component, two screens. Play History shows every play; Mystery Draw
// Orders scopes to physical wins and adds the order number and fulfilment.
const PlayHistory = (props) => <TreasureBoxPlaysHistoryList {...props} mode="plays" />;
const MysteryDrawOrders = (props) => <TreasureBoxPlaysHistoryList {...props} mode="orders" />;

// The only module that tags its own entries: both screens read the same data, so
// they share a permission, but they are reached from different sidebar groups and
// a role could reasonably be given one entry point and not the other.
const routes = [
    { path: '/dashboard/treasure-box-plays-history', name: 'Mystery Box Play History', element: PlayHistory, perm: PERMISSION.MYSTERY_BOX_VIEW },
    { path: '/dashboard/mystery-draw-orders', name: 'Mystery Draw Orders', element: MysteryDrawOrders, perm: PERMISSION.MYSTERY_BOX_VIEW },
];

export default routes;
